<template>
  <b-autocomplete
    v-model="search"
    :data="data"
    placeholder="Search user"
    field="username"
    :loading="isFetching"
    @input="getUsers()"
    @select="option => selectUser(option)">
    <template slot="empty">No results found</template>
  </b-autocomplete>
</template>

<script>
import ApiUsers from '@/api/users'
export default {
  data () {
    return {
      data: [],
      search: '',
      isFetching: false
    }
  },
  methods: {
    getUsers () {
      this.data = []
      this.isFetching = true
      ApiUsers.get.search(this.search).then(response => {
        response.body.forEach((item) => this.data.push(item))
        this.isFetching = false
      }).catch((error) => {
        this.isFetching = false
        throw error
      })
    },
    selectUser: function (option) {
      this.$emit('select-user', option)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/UserSearch.vue